var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBADB",
    d: "M21.414 10.073A.586.586 0 0 0 22 9.486V6.658c0-1.19-.967-2.158-2.155-2.158H4.155A2.16 2.16 0 0 0 2 6.658v2.828c0 .324.262.587.586.587a1.928 1.928 0 0 1 0 3.854.586.586 0 0 0-.586.587v2.828c0 1.19.967 2.158 2.155 2.158h15.69A2.16 2.16 0 0 0 22 17.342v-2.828a.586.586 0 0 0-.586-.587 1.928 1.928 0 0 1 0-3.854m-5.24 1.5-1.662 1.623.387 2.26a.586.586 0 0 1-.57.718h-.002a.6.6 0 0 1-.272-.068L12 15.024l-2.055 1.082a.585.585 0 0 1-.85-.619l.393-2.29-1.663-1.623a.587.587 0 0 1 .325-1.001l2.297-.335 1.028-2.084a.586.586 0 0 1 1.05 0l1.028 2.085 2.297.334a.586.586 0 0 1 .325 1"
  })));
};
export default SvgTicket;